import {
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import React from "react";
import useLanguages from "../../../../../explorer/hooks/useLanguages";
import { Language } from "../../../../../explorer/types";
import { useSearchParams } from "react-router-dom";
import AppModal from "../../../AppModal/AppModal";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { useUserInfo } from "../../../../../explorer/hooks/useUserInfo";
import { AppIconsPdf, AppIconsPower, AppIconsUser } from "../../../AppIcons";
import {
    LinkStyled,
    RowBox,
    useAppProfilePopupClasses,
} from "./AppProfilePopup.styles";
import Auth0Logout from "../../../../../explorer/components/Authentication/Auth0Logout";
import { AppLogout } from "../../../../configuration/componentsConfig";
import { Constants } from "../../../../configuration/Constants";

export function AppProfilePopup() {
    const [open, setOpen] = React.useState<boolean>(false);
    const { t } = useTranslation();
    const classes = useAppProfilePopupClasses();
    const lang = useLanguages().currentLanguage;

    const handlePopupOpen = (event: React.MouseEvent<HTMLElement>) => {
        setOpen(true);
    };

    // let conditionsPdf = "/assets/conditions/";
    // switch (lang) {
    //     case "it-IT":
    //         conditionsPdf += "CONDIZIONI-I.pdf";
    //         break;
    //     case "en-US":
    //         conditionsPdf += "CONDIZIONI-E.pdf";
    //         break;
    //     case "es-ES":
    //         conditionsPdf += "CONDIZIONI-S.pdf";
    //         break;
    //     case "fr-FR":
    //         conditionsPdf += "CONDIZIONI-F.pdf";
    //         break;
    //     case "de-DE":
    //         conditionsPdf += "CONDIZIONI-D.pdf";
    //         break;
    //     default:
    //         conditionsPdf += "CONDIZIONI-E.pdf";
    //         break;
    // }

    let conditionsPdf = Constants.SALES_CONDITIONS[lang];

    return (
        <React.Fragment>
            <IconButton size="large" onClick={handlePopupOpen} color="inherit">
                <AppIconsUser /> {/* sx={{ fontSize: 40 }} */}
            </IconButton>
            <AppModal
                maxWidth="sm"
                title={t("common.usersettings")}
                open={open}
                setOpen={setOpen}
            >
                <UserFields />
                <Languages />
                {/* <ChangePassword /> */}
                <RowBox sx={{ mt: 2 }}>
                    <LinkStyled
                        underline="none"
                        target="_blank"
                        href={conditionsPdf}
                        rel="noopener noreferrer"
                    >
                        <>
                            <AppIconsPdf />
                            <span>{t("common.salesCondition")}</span>
                        </>
                    </LinkStyled>
                </RowBox>
                <RowBox>
                    <AppLogout>
                        <LinkStyled underline="none" href="#">
                            <>
                                <AppIconsPower />
                                <span>{t("common.logout")}</span>
                            </>
                        </LinkStyled>
                    </AppLogout>
                </RowBox>
            </AppModal>
        </React.Fragment>
    );
}

const UserFields = () => {
    const [userInfo] = useUserInfo();
    const { t } = useTranslation();
    const classes = useAppProfilePopupClasses();

    return (
        <>
            <InputLabel>{t("common.user")}</InputLabel>
            <TextField
                variant="standard"
                value={userInfo.userName}
                fullWidth
                slotProps={{
                    htmlInput: { readOnly: true },
                }}
            />
            <InputLabel sx={classes.inputLabel}>
                {t("common.lastName")}
            </InputLabel>
            <TextField
                variant="standard"
                value={userInfo.lastName}
                fullWidth
                slotProps={{
                    htmlInput: { readOnly: true },
                }}
            />
            <InputLabel sx={classes.inputLabel}>{t("common.name")}</InputLabel>
            <TextField
                variant="standard"
                value={userInfo.firstName}
                fullWidth
                slotProps={{
                    htmlInput: { readOnly: true },
                }}
            />
            <InputLabel sx={classes.inputLabel}>{t("common.email")}</InputLabel>
            <TextField
                variant="standard"
                value={userInfo.email}
                fullWidth
                slotProps={{
                    htmlInput: { readOnly: true },
                }}
            />
        </>
    );
};

const Languages = () => {
    const languages: Language[] = useLanguages().languages;
    const currentLanguage = useLanguages().currentLanguage;
    const [searchParams, setSearchParams] = useSearchParams();
    const classes = useAppProfilePopupClasses();
    const { t } = useTranslation();
    return (
        <>
            <InputLabel sx={classes.inputLabel}>
                {t("common.language")}
            </InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={languages.find((l) => l.code === currentLanguage)?.code}
                sx={classes.select}
            >
                {languages.map((lang) => (
                    <MenuItem
                        key={"lang_" + lang.code}
                        onClick={() => {
                            searchParams.set("lang", lang.code);
                            setSearchParams(searchParams);
                        }}
                        value={lang.code}
                    >
                        {lang.description}
                    </MenuItem>
                ))}
            </Select>
        </>
    );
};
